import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Submit() {
  const [form, setForm] = useState({ text: "", speaker: "", source_url: "", submitter_email: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.text.toLowerCase().includes("to be very honest")) {
      toast.error("The quote must contain 'to be very honest'.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/submissions", form);
      setSent(true);
      toast.success("Filed. Our editors will review it.");
    } catch {
      toast.error("Could not submit. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-[820px] mx-auto px-6 md:px-10 py-12 fade-up">
      <div className="tag-red mb-3 inline-block">Submissions</div>
      <h1 className="font-display text-5xl md:text-6xl leading-[0.95]">Heard something honest?</h1>
      <p className="font-body mt-4">
        We accept quotes from any public source — speeches, interviews, panels, podcasts, printed record. Include a link and we'll verify before publishing.
      </p>

      {sent ? (
        <div className="mt-10 border-ink bg-white p-8 shadow-brut" data-testid="submit-success">
          <div className="font-ui text-[10px] text-[#FF3333]">Received</div>
          <h2 className="font-display text-3xl mt-2">Thank you. On the record.</h2>
          <p className="font-body mt-3 opacity-80">If it clears the desk, it'll appear in the feed within 48 hours.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="submit-form">
          <div>
            <label className="font-ui text-xs block mb-2">The quote *</label>
            <textarea
              required
              rows={4}
              value={form.text}
              onChange={(e) => setForm({ ...form, text: e.target.value })}
              placeholder="To be very honest, ..."
              className="border-ink bg-white px-4 py-3 font-quote text-lg w-full"
              data-testid="submit-text"
            />
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="font-ui text-xs block mb-2">Speaker *</label>
              <input
                required
                value={form.speaker}
                onChange={(e) => setForm({ ...form, speaker: e.target.value })}
                className="border-ink bg-white px-4 py-3 font-body w-full"
                data-testid="submit-speaker"
              />
            </div>
            <div>
              <label className="font-ui text-xs block mb-2">Source URL</label>
              <input
                type="url"
                value={form.source_url}
                onChange={(e) => setForm({ ...form, source_url: e.target.value })}
                placeholder="https://..."
                className="border-ink bg-white px-4 py-3 font-body w-full"
                data-testid="submit-source"
              />
            </div>
          </div>
          <div>
            <label className="font-ui text-xs block mb-2">Your email (optional)</label>
            <input
              type="email"
              value={form.submitter_email}
              onChange={(e) => setForm({ ...form, submitter_email: e.target.value })}
              className="border-ink bg-white px-4 py-3 font-body w-full md:w-1/2"
              data-testid="submit-email"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-ink" data-testid="submit-btn">
            {busy ? "Filing…" : "File the quote"}
          </button>
        </form>
      )}
    </div>
  );
}
